import { createFileRoute, Link } from '@tanstack/react-router'
import { useEffect } from 'react'
import { COLORS, FONTS, sectionInner } from '@/components/home/tokens'
import { PressReleaseView } from '@/components/press/PressReleaseView'
import { getPressReleaseBySlug } from '@/lib/pressReleases'
import { applyPressMeta, pressReleaseMeta } from '@/lib/seo'

// Every release — including the latest — has a permanent permalink here, so a
// link to a specific release keeps resolving to it after newer ones publish.
// (/press is the evergreen landing that always shows whatever's newest.)
export const Route = createFileRoute('/press_/$slug')({
  component: PressReleaseSlugPage,
})

function PressReleaseSlugPage() {
  const { slug } = Route.useParams()
  const release = getPressReleaseBySlug(slug)

  // On client-side navigation, sync the document head to this release. On first
  // load the prerendered HTML already carries it — see scripts/prerender.ts.
  useEffect(() => {
    if (release) applyPressMeta(pressReleaseMeta(release))
    else document.title = 'Press Release — Ent'
  }, [release])

  if (!release) {
    return (
      <section style={{ position: 'relative', zIndex: 10, padding: '200px 0 160px' }}>
        <div style={sectionInner}>
          <Link
            to="/press/"
            style={{
              fontFamily: FONTS.body,
              fontSize: 'var(--text-sm)',
              fontWeight: 500,
              color: COLORS.green1,
              textDecoration: 'none',
            }}
          >
            ← Back to Press
          </Link>
          <p style={{ fontFamily: FONTS.body, fontSize: 'var(--text-lg)', color: COLORS.neutral2, marginTop: 32 }}>
            That press release could not be found.
          </p>
        </div>
      </section>
    )
  }

  return <PressReleaseView release={release} />
}
